import { render, staticRenderFns } from "./FeaturedImage.vue?vue&type=template&id=8f23916e&"
import script from "./FeaturedImage.vue?vue&type=script&lang=js&"
export * from "./FeaturedImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports